import moment from 'moment'
import React from 'react'
import LinesEllipsis from 'react-lines-ellipsis'
import {Link} from 'react-router-dom'
import {Consumer} from '../../context'
import {enhancedWithRowData} from '../../helpers/utils'
import {subdomainLink} from '../../helpers/url'
import {viewerGuard} from 'helpers/url'

function LessonColumn ({rowData}) {
  const {type, lesson, lessonName, content} = rowData
  return (<Consumer>{context => {
    switch (type) {
      case 'schedule':
        const title = `${lesson} - ${lessonName}`
        return (
          <a
            className="schedule link"
            title={title}
            {...viewerGuard({href: context.locked ? '#' : subdomainLink('www', 'preview', `?lesson=${lesson}`), target: "_blank"})}
          >
            {title}
          </a>)
      case 'uploaded':
        const zipName = `${content.title.replace(/.epl$/, '')}.zip`
        return (
          <a
            className="uploaded link"
            title={content.title}
            {...viewerGuard({target: "_blank", href: context.locked ? '#' : subdomainLink('api-support', 'catalog',  'downloadUploaded', `?id=${rowData.title}`)})}
          >
            <LinesEllipsis
              text={content.title}
              maxLine={2}
              ellipsis="..."
              trimRight
              basedOn='letters'
            />
          </a>
        )
      default: return (<div />)
    }
  }}</Consumer>)
}

function DateColumn (row) {
  const start = moment(row.value).toISOString()
  const query = {start, end: start}
  return (<Consumer>{context => {
    return (
      <Link
        className="date link"
        to={context.locked ? '#' : context.link({}, '/:languageId/:role/calendars/day',{query})}
      >
        {moment(row.value).format(context.translate('moment-date-format'))}
      </Link>
    )
  }}</Consumer>)
}

function GroupColumn ({rowData}) {
  return (<Consumer>{context => {
    return (
      <Link
        className="group link"
        title={rowData.group}
        to={context.locked ? '#' : context.link({course: rowData.groupCourse}, '/:languageId/:role/my-courses/:course')}
      >
        <LinesEllipsis
          text={rowData.group}
          maxLine={2}
          ellipsis="..."
          trimRight
          basedOn='letters'
        />
      </Link>
    )
  }}</Consumer>)
}

const columns = {
    date: DateColumn,
    group: enhancedWithRowData(GroupColumn),
    lesson: enhancedWithRowData(LessonColumn)
}

export default columns
